import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const ChevronDown: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 12 5" {...props}>
    <path d="M1.719 0l4.208 4.05L10.136 0l1.293 1.247-5.502 5.304L.426 1.247z" />
  </Icon>
);
